<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppRawButton, AppSvgIcon } from '@libs/ui';

interface PriceGuaranteeBannerEmits {
  (eventName: 'learn-more'): void;
}

const emit = defineEmits<PriceGuaranteeBannerEmits>();

const { t } = i18n.global;
</script>

<template>
  <AppRawButton class="price-guarantee-banner" @click="emit('learn-more')">
    <div class="content">
      <span class="price-guarantee-banner-title">
        {{ t('price_guarantee.banner.title') }}
      </span>
      <span class="price-guarantee-banner-description">
        {{ t('price_guarantee.banner.description') }}
      </span>
      <AppSvgIcon name="infoCircle" size="18" class="icon" />
    </div>
  </AppRawButton>
</template>

<style scoped lang="scss">
.price-guarantee-banner {
  display: flex;
  gap: var(--spacing-12);
  padding: var(--spacing-12) 0;
  width: 100%;
  text-align: left;
  color: var(--color-neutral-70);
  align-items: center;
  justify-content: center;

  @include for-less-or-equal-than-1199-px {
    padding: var(--spacing-8);
  }

  @include on-hover {
    cursor: pointer;
    background: var(--color-white);
    border-radius: var(--border-radius-12);
    transition: background var(--transition-short);
  }

  .content {
    white-space: nowrap;
    text-align: center;

    .price-guarantee-banner-title {
      @include font-body-m-bold;
    }

    .price-guarantee-banner-description {
      @include font-body-m-light;
      white-space: pre-wrap;
      margin-left: var(--spacing-4);
    }

    .icon {
      display: inline-block;
      transform: translate(4px, 4px);
    }
  }
}
</style>
